import React from "react";
import styles from "./AboutArtYerkirSection.module.scss";
import FacebookIcon from "components/svgs/FacebookIcon";
import InstagramIcon from "components/svgs/InstagramIcon";
import EnvelopeIcon from "components/svgs/EnvelopeIcon";
import PhoneIcon from "components/svgs/PhoneIcon";

const AboutArtYerkirSection = () => {
  return (
    <div className={styles.aboutArtYerkirSectionContainer}>
      <h1 className={styles.mainTitle}>about art yerkir</h1>
      <p className={styles.description}>Where does it come from?</p>
      <p className={styles.description}>
        Contrary to popular belief, Lorem Ipsum is not simply random text. It
        has roots in a piece of classical Latin literature from 45 BC, making it
        over 2000 years old. Richard McClintock, a Latin professor at
        Hampden-Sydney College in Virginia, looked up one of the more obscure
        Latin words, consectetur, from a Lorem Ipsum passage, and going through
        the cites of the word in classical literature, discovered the
        undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33
        of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by
        Cicero, written in 45 BC. This book is a treatise on the theory of
        ethics, very popular during the Renaissance. The first line of Lorem
        Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section
        1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is
        reproduced below for those interested. Sections 1.10.32 and 1.10.33 from
        "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their
        exact original form, accompanied by English versions from the 1911.
      </p>
      <p className={styles.description}>
        Contrary to popular belief, Lorem Ipsum is not simply random text. It
        has roots in a piece of classical Latin literature from 45 BC, making it
        over 2000 years old. Richard McClintock, a Latin professor at
        Hampden-Sydney College in Virginia, looked up one of the more obscure
        Latin words, consectetur, from a Lorem Ipsum passage, and going through
        the cites of the word in classical literature, discovered the
        undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33
        of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by
        Cicero, written in 45 BC. This book is a treatise on the theory of
        ethics, very popular during the Renaissance. The first line of Lorem
        Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section
        1.10.32.
      </p>
      <div className={styles.social}>
        <span>
          All materials are available on the ART Yerkir Facebook and Instagram
          pages:
        </span>
        <a href="https://facebook.com" target="_blank" rel="noreferrer">
          <FacebookIcon />
        </a>
        <a href="https://instagram.com" target="_blank" rel="noreferrer">
          <InstagramIcon />
        </a>
      </div>
      <div className={styles.contactInfo}>
        <div className={styles.title}>Contact Information:</div>
        <a href="mailto:panarmenia_arterkir@gmail.com">
          <EnvelopeIcon />
          panarmenia_arterkir@gmail.com
        </a>
        <a href="tel:+374 55 533128">
          <PhoneIcon />
          +374 55 533128
        </a>
      </div>
    </div>
  );
};

export default AboutArtYerkirSection;
